export * from './MediaUiASkip2BackIcon';
export * from './MediaUiASkip2BackIcon16Light';
export * from './MediaUiASkip2BackIcon16Regular';
export * from './MediaUiASkip2BackIcon16Solid';
export * from './MediaUiASkip2BackIcon20Light';
export * from './MediaUiASkip2BackIcon20Regular';
export * from './MediaUiASkip2BackIcon20Solid';
export * from './MediaUiASkip2BackIcon24Regular';
export * from './MediaUiASkip2BackIcon24Solid';
export * from './MediaUiASkip2BackIcon32Regular';
export * from './MediaUiASkip2BackIcon64Regular';
